import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import Select from 'react-select';

import { getAvailableTags } from 'lib/enums/GlobalManufacturerHarvestTags';
import TagBadge from 'components/shared/TagBadge';

const AVAILABLE_TAGS = getAvailableTags();

function TagEditor({ show, onHide, currentTags = [], onSave, isLoading = false }) {
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (show) {
      const tagOptions = currentTags.map(tag => ({
        value: tag,
        label: tag,
      }));
      setSelectedTags(tagOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleSave = () => {
    const tags = selectedTags.map(option => option.value);
    onSave(tags);
  };

  const handleRemoveTag = tagToRemove => {
    setSelectedTags(selectedTags.filter(tag => tag.value !== tagToRemove));
  };

  return (
    <Modal show={show} onHide={isLoading ? undefined : onHide} centered>
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>Edit Tags</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Select Tags</Form.Label>
          <Select
            isMulti
            isClearable
            options={AVAILABLE_TAGS}
            value={selectedTags}
            onChange={setSelectedTags}
            isDisabled={isLoading}
            placeholder="Select or type to add tags..."
            isSearchable
          />
        </Form.Group>
        {selectedTags.length > 0 && (
          <div className={css(styles.selectedTags)}>
            <Form.Label className="mt-3">Selected Tags:</Form.Label>
            <div className={css(styles.tagList)}>
              {selectedTags.map(option => (
                <TagBadge
                  key={option.value}
                  tag={option.label}
                  variant="info"
                  onRemove={handleRemoveTag}
                />
              ))}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const styles = StyleSheet.create({
  selectedTags: {
    marginTop: 16,
  },
  tagList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 8,
  },
});

TagEditor.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  currentTags: PropTypes.arrayOf(PropTypes.string),
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default TagEditor;
